import {ConfigContext} from '../../config/context/index.js'
import {SpecificationVehiclesValueObject} from './SpecificationVehiclesValueObject.js'

export class BodyTypeSpecificationVehiclesValueObject extends SpecificationVehiclesValueObject {
  constructor({icon, id, name}) {
    super({icon, id, name})
  }

  static createFromId({id}) {
    if (!SpecificationVehiclesValueObject.isValidId({id})) return BodyTypeSpecificationVehiclesValueObject.empty()

    const {BODY_TYPES} = ConfigContext.get('vehicleSpecifications')

    const {icon, name} = BODY_TYPES[id] || {}

    return BodyTypeSpecificationVehiclesValueObject.createFromLiterals({icon, id, name})
  }
}
